import React from 'react';
import { Sun, Moon } from 'lucide-react';

/**
 * Theme toggle component with sun/moon icons
 * Shows both icons inside a pill-shaped track, with a sliding thumb animation
 */
const ThemeModeToggle = ({ isDark, onToggle, className = '' }) => {
  return (
    <button
      onClick={(e) => {
        // Wipe origin = button centre (also right for keyboard activation)
        const rect = e.currentTarget.getBoundingClientRect();
        onToggle({ x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 });
      }}
      className={`relative flex items-center w-[68px] h-[32px] rounded-full bg-[#E8EBE9] dark:bg-[#282a29] p-[2px] transition-colors focus:outline-none ${className}`}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Animated thumb/highlight */}
      <div
        className={`absolute w-[28px] h-[28px] rounded-full bg-white dark:bg-[#4a4d4c] shadow-sm transition-transform duration-300 ease-in-out ${
          isDark ? 'translate-x-[34px]' : 'translate-x-[2px]'
        }`}
      />

      {/* Icons container */}
      <div className="relative flex items-center justify-between w-full px-[2px]">
        {/* Light mode option (Sun) */}
        <div className="flex items-center justify-center w-[28px] h-[28px]">
          <Sun 
            size={16} 
            className={`transition-colors duration-300 ${
              !isDark ? 'text-[#282A29] dark:text-[#f0f5f2]' : 'text-[#828382] dark:text-[#6b6b6b]'
            }`}
            strokeWidth={2}
          />
        </div>

        {/* Dark mode option (Moon) */}
        <div className="flex items-center justify-center w-[28px] h-[28px]">
          <Moon 
            size={16} 
            className={`transition-colors duration-300 ${
              isDark ? 'text-[#282A29] dark:text-[#f0f5f2]' : 'text-[#828382] dark:text-[#6b6b6b]'
            }`}
            strokeWidth={0}
            fill={isDark ? '#fff' : '#828382'}
          />
        </div>
      </div>
    </button>
  );
};

export default ThemeModeToggle;
